import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.956 9.001a1 1 0 0 1 1.043 1.035c-.088 2.444-.63 3.983-1.646 5.204a1 1 0 0 1-.076.081c-.984.946-2.305 1.509-3.956 1.658a1 1 0 0 1-.154.002 9 9 0 0 1-3.638-1.018 1 1 0 0 1-.129-.082c-.573-.43-1.158-.987-1.609-1.79-.451-.802-.734-1.793-.79-3.047a1 1 0 0 1 1.035-1.043c2.322.084 3.827.577 5.019 1.499q.029-.052.064-.1c.43-.572.987-1.158 1.79-1.609.802-.451 1.793-.734 3.047-.79m-1.05 2.148a3.9 3.9 0 0 0-1.02.385c-.463.26-.81.603-1.117 1.002a6.7 6.7 0 0 0-.475 1.18 1 1 0 0 1-1.842.187 3.5 3.5 0 0 0-.539-.757c-.614-.497-1.408-.879-2.764-1.053.098.414.232.747.385 1.02.26.463.602.81 1.001 1.117a7 7 0 0 0 2.689.747c1.213-.122 2.045-.52 2.63-1.066.498-.613.878-1.407 1.052-2.762"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21 11a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3zm2 4a5 5 0 0 1-5 5H6a5 5 0 0 1-5-5v-4a5 5 0 0 1 5-5h12a5 5 0 0 1 5 5zm-13 5a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2zm8 0a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2zM14 4a1 1 0 1 1 0 2h-4a1 1 0 0 1 0-2z"
    }, null, -1)
  ]))]))
}
export default { render: render }